module.exports = __webpack_public_path__ + "img/spezialisierungen_1280.cb32fa1d.webp";